export default __webpack_public_path__ + "static/media/Plywwod_Deck.96a8c7fb.JPG";